import classNames from "clsx";

import Table, { TableProps } from "react-bootstrap/Table";
import Spinner from "react-bootstrap/Spinner";

import { FaTrash } from "react-icons/fa";

import { useApi } from "@/hooks/useApi";
import { useSwal } from "@/hooks/useSwal";
import { transformData } from "@/utils/transformData";
import { useThemeMode } from "@/../_metronic/partials";
import { procedureMap } from "@/utils/mappings/procedure";
import { useThemeClassNames } from "@/hooks/useThemeClassNames";

import "./styles.scss";

type Props = TableProps & {
	isLoading?: boolean;
	permitId?: number;
	procedures: Procedure[];
	setProcedures?: (procedures: Procedure[]) => void;
	actionsColumn?: boolean;
};

export function ProceduresTable({
	isLoading = false,
	permitId,
	procedures,
	setProcedures,
	actionsColumn = false,
	...rest
}: Props) {
	const { border, background } = useThemeClassNames();
	const { mode } = useThemeMode();
	const { Toast } = useSwal();
	const { api } = useApi();

	async function handleDeleteProcedure(procedureCode: string) {
		try {
			const { data } = await api.delete(
				`/hospitalization-permits/${permitId}/procedures/${procedureCode}`
			);

			if (setProcedures) {
				const transformedProcedures = transformData<Procedure[]>(data, procedureMap);

				setProcedures(transformedProcedures);
			}

			Toast.fire({
				text: "Procedimento excluido com sucesso.",
				icon: "success",
			});
		} catch (error) {
			console.log(error);

			Toast.fire({
				text: "Não foi possível excluir este procedimento.",
				icon: "error",
			});
		}
	}

	const backgroundButtonClassNames = mode === "dark" ? "btn-light" : "theme-button-light";

	return isLoading ? (
		<div className="w-100 text-center">
			<Spinner variant="primary" animation="border" />
		</div>
	) : (
		<div className="table-responsive">
			<Table className={classNames("table-procedures fs-7", border)} bordered {...rest}>
				<thead className={classNames("text-center", background)}>
					<tr>
						<th className="w-50">PROCEDIMENTOS</th>
						<th className="w-25">QUANTIDADE</th>
						{actionsColumn && <th>AÇÕES</th>}
					</tr>
				</thead>

				<tbody className="white-space-no-wrap align-middle text-center">
					{procedures?.map((procedure) => (
						<tr key={procedure.code}>
							<td>
								{procedure.code} - {procedure.name}
							</td>
							<td>{procedure.pivot?.quantity}</td>
							{actionsColumn && (
								<td>
									<button
										title="Excluir"
										className={classNames(
											"btn shadow hover-elevate-up px-4 py-2 text-primary",
											backgroundButtonClassNames
										)}
										onClick={() => handleDeleteProcedure(procedure.code)}
									>
										<FaTrash />
									</button>
								</td>
							)}
						</tr>
					))}
				</tbody>
			</Table>
		</div>
	);
}
